import { useSessionStore } from '../store/sessionStore';
import { MessagesSquare, Users, History } from 'lucide-react';
import { MessageLog } from './MessageLog';
import { AgentTabs } from './AgentTabs';
import { ReplayScrubber } from './ReplayScrubber';
import './DetailPanel.css';

type Tab = 'messages' | 'agents' | 'replay';

export function DetailPanel() {
  const { detailPanelTab, setDetailPanelTab, anomalies } = useSessionStore();
  const replayAlertCount = anomalies.length;
  const tabs = [
    { id: 'messages' as Tab, label: 'Messages', icon: MessagesSquare },
    { id: 'agents' as Tab, label: 'Agents', icon: Users },
    { id: 'replay' as Tab, label: 'Replay', icon: History, badge: replayAlertCount },
  ];

  return (
    <div className="detail-panel">
      <div className="detail-tabs-bar">
        {tabs.map(({ id, label, icon: Icon, badge }) => (
          <button
            key={id}
            className={`detail-tab ${detailPanelTab === id ? 'detail-tab--active' : ''}`}
            onClick={() => setDetailPanelTab(id)}
          >
            <Icon size={13} />
            {label}
            {badge !== undefined && badge > 0 && (
              <span className="detail-tab-badge">{badge}</span>
            )}
          </button>
        ))}
      </div>

      <div className="detail-panel-content">
        {detailPanelTab === 'messages' && <MessageLog />}
        {detailPanelTab === 'agents' && <AgentTabs />}
        {detailPanelTab === 'replay' && <ReplayScrubber />}
      </div>
    </div>
  );
}
